<script setup>
import { rem ,isTpad} from '@common/utils'


const emit = defineEmits()
const props = defineProps({
  icon: String,
  btns: [Array, Object],
  isUnfold: {
    type:Boolean,
    default:true
  }
})

// 参数都转为数组格式
const btnList = computed(() => {
  // 插槽方式
  if (!props.btns) return [{
    selected: true,
    icon: props.icon
  }]

  // 数组方式
  if (Array.isArray(props.btns)) return props.btns

  // 对象方式
  return [{ selected: true, ...props.btns }]
})

// 按钮划过长度维护
const button = ref()
const toggleFold = unfold => {
  if (unfold && props.isUnfold) {
    button.value.style.width = rem(button.value.scrollWidth)
  } else {
    button.value.removeAttribute("style")
  }
}
</script>

<template>
  <ul
  :class="isTpad ? 'nio-button-fold-pad' : 'nio-button-fold'"
    ref="button"
    @mouseover="toggleFold(true)"
    @mouseout="toggleFold(false)"
  >
    <li
      v-for="({ icon, text, selected }, index) in btnList"
      :key="text + icon"
      :class="{ 'nio-selected': selected }"
      @click="emit('click', index)"
    >
      <!-- icon 都需要添加 raw 属性 这样不会强制修改icon内部颜色 -->
      <nio-icon :type="icon" raw/>
      <slot>{{ text }}</slot>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.nio-button-fold {
  @include transition;
  @include flex-center($justify: flex-start);
  white-space: nowrap;
  width: rem(30);
  height: rem(30);
  border-radius: rem(15);
  
  color: #fff;
  font-size: rem(11);
  line-height: rem(18);
  background-color: rgba(0, 0, 0, 0.15);
  overflow: hidden;

  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.4);
  }

  li {
    opacity: 0.5;
    cursor: pointer;
    line-height: rem(30);
    padding: 0 rem(6) 0 rem(6);

    &:last-child {
      padding-right: rem(10)
    }

    &:hover {
      opacity: 0.8;
    }

    // 选中
    &.nio-selected,
    &:active {
      opacity: 1;
      display: flex;
      align-items: center;
    }
    .nio-icon {
      margin-right: rem(6);
      width: rem(18);
      height: rem(18);
    }
  }
}
.nio-button-fold-pad{
  @include transition;
  @include flex-center($justify: flex-start);
  white-space: nowrap;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  background-color: rgba(0, 0, 0, 0.15);
  overflow: hidden;

  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.4);
  }

  li {
    opacity: 0.5;
    cursor: pointer;
    line-height: 30px;
    padding: 0 6px 0 6px;

    &:last-child {
      padding-right: 10px
    }

    &:hover {
      opacity: 0.8;
    }

    // 选中
    &.nio-selected,
    &:active {
      opacity: 1;
      display: flex;
      align-items: center;
    }
    .nio-icon {
      margin-right: 6px;
      width: 18px;
      height: 18px;
    }
  }
}
</style>
